import React from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { STYLED_DOUBLE_SELECT } from '../../../constants/styles-constants';
import { LettersInput } from './letters-input';
import { TratoSelect } from './trato-select';

export function TratoNombreInput() {
	return (
		<div style={{ display: 'flex', flexDirection: 'row' }}>
			<TratoSelect width={STYLED_DOUBLE_SELECT.first.width} required />
			<div
				style={{
					width: STYLED_DOUBLE_SELECT.second.width,
					marginLeft: STYLED_DOUBLE_SELECT.second.marginLeft,
				}}
			>
				<LettersInput name={FIELD_NAME.NAME} required />
			</div>
		</div>
	);
}
